import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-required-asterisk',
  template: `*`,
  styleUrl: './ga-required-asterisk.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class GaRequiredAsteriskComponent {}
